import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { cyan, purple } from '@mui/material/colors'

let theme = createTheme({
    palette: {
        primary: { main:  cyan[500], contrastText: "#fff" },
        secondary: { main: purple[500], contrastText: "#fff" },
        // error: { main: purple[500] },
    },
    spacing: 8,
});

theme = responsiveFontSizes(theme);

export default theme;